import type { FormatterArgs } from '@/services/types/formatter';

export default ({ data, key }: FormatterArgs) => ({
  kind: 'class-name',
  text: String(data[key] ?? ''),
});
